import { css } from "@emotion/css"

import type { SeminarValues } from "../api/seminarApi"
import { formatSite, formatSeminarDateTime } from "../logic/SeminarFormatter"

type Props = {
  seminar: SeminarValues
}

const SeminarSummary = ({ seminar }: Props) => {
  return (
    <div>
      <div className={styles.container}>
        <div className={styles.title}>お申込みセミナー</div>
        <div className={styles.subContainer}>
          <span className={styles.label}>セミナー名</span>
          <span className={styles.field}> {seminar.seminarName}</span>
        </div>
        <div className={styles.subContainer}>
          <span className={styles.label}>開催日</span>
          <span className={styles.field}> {formatSeminarDateTime(seminar)}</span>
        </div>
        <div className={styles.subContainer}>
          <span className={styles.label}>開催場所</span>
          <span className={styles.field}> {formatSite(seminar)} </span>
        </div>
      </div>
    </div>
  )
}

export default SeminarSummary

const styles = {
  container: css`
    width: 100%;
    padding: 19px 19px 15px 19px;
    border: 2px solid;
    border-color: #39b54a;
  `,
  title: css`
    margin-top: 1px;
    margin-bottom: 14px;
    font-size: 18px;
    font-weight: bold;
    line-height: 1;
    color: #39b54a;
  `,
  subContainer: css`
    display: flex;
    margin-top: 12px;
  `,
  label: css`
    flex: 1;
    width: 200px;
    font-size: 14px;
    line-height: 22px;
    color: #4d4d4d;
  `,
  field: css`
    width: 498px;
    font-size: 14px;
    line-height: 22px;
    color: #4d4d4d;
  `,
}
